import React, { Component } from 'react';
import './App.css';
import Buttons from './Buttons.js';

function validQuery(str) {
  const firstChar = str.substring(0, 1) !== '&';
  const containsForbidden = /^[a-zA-Z0-9?!. ]*$/.test(str);
  const containsChar = /[a-zA-Z0-9]/i.test(str);
  return (firstChar && containsForbidden && containsChar);
}

const injectSearch = { callback: function(){} };
class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      latestSearch: '',
      alert: '',
      alertCounter: 0
    };
    this.handleChange = this.handleChange.bind(this);
  }

  //When tab is changed
  changeQuery(query) {
    this.setState({
      value: query,
      latestSearch: query
    });
  }

  //if url contains query
  selectUrlQuery(query) {
    this.setState({ value: query }, () => {
      this.onSubmit();
    });
  }

  componentWillMount() {
    injectSearch.callback = (text) => {
      this.setState({
        value: text
      });
      this.props.search(text);
    }
  }

   componentDidUpdate(){
    if(this.props.currentQuery === "New Search"){
       this.refs.input.focus();
    }
  }

  render() {
    return (
      <div className="searchArea">
        <div id="alert_area" className="searchArea__alert">
          <p id="alert_text" className="searchArea__alert__text">{this.state.alert}</p>
        </div>
        <div className="searchArea__field">
          <div className="searchArea__button" onClick={this.onSubmit.bind(this)} dangerouslySetInnerHTML={{ __html: '<svg fill="#FFFFFF" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'}} />
          <input className="searchbar searchArea__input" type="search" placeholder="Search" autoComplete="off"
            ref="input"
            value={this.state.value}
            onKeyDown={this.handleKeyPress.bind(this)}
            onChange={this.handleChange}
            maxLength={50}
            autoFocus />
        </div>
        <Buttons history={this.props.history} tabs={this.props.tabs} recentSearches={this.props.recentSearches}
         changeTab={this.props.changeTab}/>
      </div>
    );
  }

  handleKeyPress(target) {
    if(target.keyCode === 13){
      this.onSubmit();
      if(window.mobilecheck()){
        document.activeElement.blur();
      }
    }
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
      alert: ''
    });
  }

  onSubmit() {
    const text = this.state.value
     if (text && this.state.latestSearch !== text && text.length > 2 && validQuery(text)) {
      this.setState({
        numResult: 0,
        latestSearch: text,
        alert: '',
        alertCounter: 0
      });
      this.props.search(this.state.value);
    }
    else {
      if(!text){
        this.setState({alert: 'Type something to search.'});
      }
      else if(this.state.latestSearch === text){
        this.setState({alertCounter: this.state.alertCounter + 1});
        if(this.state.alertCounter >= 1){
            this.setState({alert: "Results for this search are already shown below."});
        }
      }
      else if(text.length <= 2){
        this.setState({alert: "Your search query must be 3 to 50 characters long."});
      }
      else if(!/[a-zA-Z0-9]/i.test(text) &&
              /^[a-zA-Z0-9?!. ]*$/.test(text)){
        this.setState({alert: "Your search must also contain some of the following letters: a-z, A-Z, 0-9"});
      }
      else if(!validQuery(text)){
        this.setState({alert: "Allowed characters are a-z, A-Z, 0-9, .!?."});
      }
    }
  }

}

export { Search, injectSearch };



// WEBPACK FOOTER //
// ./client/src/Search.js